export default __webpack_public_path__ + "static/media/seedfund-need.828c1ac4.svg";